import React from "react";
import enrolmentForm from "../../assets/enrolment/Enrolment_Form.pdf";
import enrolmentBottomImage from "../../assets/enrolment/bottomEnrolment.jpg";
import SideBar from "../master/SideBar";
import ContentWrapper from "../master/ContentWrapper";
import { EnrolmentSidebarLink } from "../const";
import PageTitle from "../master/PageTittle";

const EnrolmentContent = () => (
  <div className="container">
    <ContentWrapper sidebar={true} narrow={true}>
      <div className="content">
        <PageTitle title="The Enrolment Process" />

        <p>The enrolment process has three stages:</p>
        <PageTitle title="1. Application for Student Enrolment" variant="h3" />
        <h3></h3>
        <p>
          Application for Student Enrolment consists of lodging an Application
          for Student Enrolment accompanied by a copy of the Birth Certificate
          and payment of the non-refundable Application Administration Fee. This
          secures the student a place on the Waiting List. Where application is
          for entry into Kindergarten, students must turn five (5) years of age
          by 31 July in the year of entry to be eligible to apply.
        </p>

        <PageTitle title="2. College Enrolment Interview" variant="h3" />

        <p>
          The College will conduct an enrolment Interview and may request
          further documentation. All documentation must be provided by the
          parents/carers prior to the College considering making an Enrolment
          Offer.
        </p>

        <PageTitle title="3. Confirmation of the Enrolment" variant="h3" />

        <p>
          Enrolment is confirmed when the signed Letter of Offer is received by
          the College and the non-refundable Acceptance Fee is paid by the due
          date. The Enrolment Contract and Acceptance Fee are also required in
          the case of scholarship recipients. Enrolment fees are not refundable
          where a student does not take up or discontinues their enrolment.
        </p>
        <a
          href={enrolmentForm}
          type="button"
          className="btn enrolmentFormButton"
        >
          Download Enrolment Form
        </a>
      </div>
      <SideBar items={EnrolmentSidebarLink} title="Enrolments" />
    </ContentWrapper>

    <img
      src={enrolmentBottomImage}
      className="img-fluid justify-content-center "
      height={600}
      alt="..."
    />
  </div>
);

export default EnrolmentContent;
